export default __webpack_public_path__ + "static/media/beauty.c571798b.PNG";